/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshservicePolicyMapping extends models.FreshserviceMappingBase {
    getFixupPrototypeFunction() { return FreshservicePolicyMapping.fixupPrototype; }

    static newInstance(model: Partial<FreshservicePolicyMapping>): FreshservicePolicyMapping {
        let obj = Object.assign(new FreshservicePolicyMapping(), model);
        FreshservicePolicyMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshservicePolicyMapping>): FreshservicePolicyMapping {
        if (!model) return null;
        return FreshservicePolicyMapping.newInstance(<FreshservicePolicyMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshservicePolicyMapping) {
        if (!obj) return;

        models.FreshservicePolicyMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshservicePolicyMapping): boolean {
        if (models.FreshserviceMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshservicePolicyMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.FreshserviceIncidentConfigurationMappingForPolicyViolation.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Policy attribute enums for Freshservice
     */
    description_attributes: Array<models.DescriptionAttributeForItsmPolicy>;

    /**
     * List of Freshservice attribute mappings
     */
    attribute_mappings: Array<models.FreshserviceIncidentConfigurationMappingForPolicyViolation>;

}
